import type { MessagingCreateChatRoom201LastMessageBasicInfoAllOf } from './messagingCreateChatRoom201LastMessageBasicInfoAllOf';
import type { MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwo } from './messagingCreateChatRoom201LastMessageBasicInfoAllOfTwo';

export type MessagingCreateChatRoom201LastMessageBasicInfo = MessagingCreateChatRoom201LastMessageBasicInfoAllOf & MessagingCreateChatRoom201LastMessageBasicInfoAllOfTwo;
